import { render, staticRenderFns } from "./CertAll.vue?vue&type=template&id=2896dad2&"
import script from "./CertAll.vue?vue&type=script&lang=js&"
export * from "./CertAll.vue?vue&type=script&lang=js&"
import style0 from "./CertAll.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports